module.exports = __webpack_public_path__ + "static/media/63.3ee690d6.jpg";